// extracted by mini-css-extract-plugin
module.exports = {"title":"PopupHeader_title__9jf4w"};